import {Browser, BrowserCapabilityName} from "./browser";
import {platformFromString} from '@webmate-web-core/shared/types/platform';

export interface Capability {
    browserType: string,
    version: string,
    platform: string,
    supportsProxy: boolean,
    browserlanguage?: string,
    model?: string
}

export function browserFromCapability(c: Capability) {
    return new Browser(c.browserType, c.version, platformFromString(c.platform), {}, c.model, {"selenium.webdriverSupport": true});
}
